import { jsPDF } from 'jspdf';

/**
 * Gera um relatório profissional de obras fixas em PDF
 */
export const gerarRelatorioObrasFixas = (obras, filtros = {}) => {
  // Criar documento PDF
  const doc = new jsPDF();
  
  // Variáveis para totalizadores
  let valorTotalObras = 0;
  let valorTotalMedido = 0;
  let totalItens = 0;
  let totalItensMedidos = 0;
  let totalMedicoes = 0;
  
  // Cores e estilos
  const corPrimaria = [50, 50, 50]; // Cinza escuro
  const corSecundaria = [100, 100, 100]; // Cinza médio
  const corDestaque = [156, 39, 176]; // Roxo (cor do módulo de obras fixas)
  const corFundo = [240, 240, 240]; // Cinza claro
  
  // Adicionar cabeçalho
  doc.setFillColor(...corDestaque);
  doc.rect(0, 0, 210, 25, 'F');
  
  doc.setFontSize(18);
  doc.setTextColor(255);
  doc.text('Relatório de Obras Fixas', 105, 15, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setTextColor(230);
  doc.text(`Prefeitura Teste`, 105, 22, { align: 'center' });
  
  // Adicionar data e filtros
  doc.setTextColor(...corPrimaria);
  doc.setFontSize(9);
  doc.text(`Gerado em: ${new Date().toLocaleDateString('pt-BR')}`, 15, 32);
  
  // Adicionar filtros aplicados, se houver
  if (Object.keys(filtros).length > 0) {
    let filtroTexto = 'Filtros aplicados: ';
    
    if (filtros.status) {
      filtroTexto += `Status: ${filtros.status}, `;
    }
    
    if (filtros.termo) {
      filtroTexto += `Busca: ${filtros.termo}, `;
    }
    
    // Remover a última vírgula e espaço
    filtroTexto = filtroTexto.replace(/, $/, '');
    
    doc.text(filtroTexto, 15, 37);
  }
  
  // Linha separadora
  doc.setDrawColor(...corDestaque);
  doc.setLineWidth(0.5);
  doc.line(15, 40, 195, 40);
  
  // Posição Y atual no documento
  let yPos = 50;
  
  // Agrupar obras por status
  const obrasPorStatus = {};
  
  obras.forEach(obra => {
    const status = obra.status || 'Sem Status';
    
    if (!obrasPorStatus[status]) {
      obrasPorStatus[status] = [];
    }
    
    obrasPorStatus[status].push(obra);
    
    // Calcular totalizadores
    valorTotalObras += obra.valor || 0;
    
    let valorMedidoObra = 0;
    let itensMedidosObra = 0;
    
    if (obra.itens && obra.itens.length > 0) {
      totalItens += obra.itens.length;
      
      obra.itens.forEach(item => {
        valorMedidoObra += item.totalMedido || 0;
        if (item.quantidadeMedida > 0) {
          itensMedidosObra++;
        }
        
        if (item.detalhes && item.detalhes.length > 0) {
          totalMedicoes += item.detalhes.length;
        }
      });
    }
    
    valorTotalMedido += valorMedidoObra;
    totalItensMedidos += itensMedidosObra;
  });
  
  // Para cada status
  Object.entries(obrasPorStatus).forEach(([status, obrasDoStatus]) => {
    // Verificar se precisa adicionar nova página
    if (yPos > 240) {
      doc.addPage();
      yPos = 20;
    }
    
    // Título do status
    doc.setFillColor(...corFundo);
    doc.rect(15, yPos - 5, 180, 10, 'F');
    doc.setDrawColor(...corDestaque);
    doc.setLineWidth(0.5);
    doc.line(15, yPos - 5, 15, yPos + 5);
    
    doc.setFontSize(12);
    doc.setTextColor(...corDestaque);
    doc.text(`${status} (${obrasDoStatus.length} obras)`, 20, yPos);
    yPos += 10;
    
    // Para cada obra
    obrasDoStatus.forEach((obra, index) => {
      // Verificar se precisa adicionar nova página
      if (yPos > 240) {
        doc.addPage();
        yPos = 20;
      }
      
      // Cabeçalho da obra
      doc.setFillColor(...corFundo);
      doc.rect(15, yPos - 4, 180, 8, 'F');
      doc.setFontSize(10);
      doc.setTextColor(...corPrimaria);
      doc.setFont('helvetica', 'bold');
      doc.text(`${index + 1}. ${obra.nome}`, 20, yPos);
      doc.setFont('helvetica', 'normal');
      yPos += 8;
      
      // Informações da obra
      doc.setFontSize(9);
      doc.setTextColor(...corSecundaria);
      
      // Primeira linha de informações
      doc.text(`Empreiteiro: ${obra.empreiteiro}`, 20, yPos);
      doc.text(`Valor Total: ${formatarMoeda(obra.valor)}`, 110, yPos);
      yPos += 5;
      
      // Segunda linha de informações
      doc.text(`Contrato: ${obra.contrato || 'Não informado'}`, 20, yPos);
      doc.text(`Licitação: ${obra.licitacao || 'Não informada'}`, 110, yPos);
      yPos += 5;
      
      // Terceira linha de informações
      doc.text(`Início: ${formatarData(obra.dataInicio)}`, 20, yPos);
      doc.text(`Previsão de Término: ${formatarData(obra.dataPrevisaoTermino)}`, 110, yPos);
      yPos += 5;
      
      // Quarta linha de informações
      doc.text(`Gestor: ${obra.gestor || 'Não informado'}`, 20, yPos);
      doc.text(`Fiscais: ${obra.fiscaisObras || 'Não informados'}`, 110, yPos);
      yPos += 5;
      
      // Quinta linha de informações - Localização
      if (obra.localizacao) {
        doc.text(`Localização: ${obra.localizacao.nome || 'Não informada'}`, 20, yPos);
        doc.text(`Coordenadas: ${obra.localizacao.latitude?.toFixed(6) || '0'}, ${obra.localizacao.longitude?.toFixed(6) || '0'}`, 110, yPos);
        yPos += 8;
      } else {
        yPos += 3;
      }
      
      // Itens da obra
      if (obra.itens && obra.itens.length > 0) {
        // Calcular progresso e valores
        let valorMedido = 0;
        let itensMedidos = 0;
        
        obra.itens.forEach(item => {
          valorMedido += item.totalMedido || 0;
          if (item.quantidadeMedida > 0) {
            itensMedidos++;
          }
        });
        
        const percentualConcluido = obra.valor > 0 ? (valorMedido / obra.valor) * 100 : 0;
        const percentualItensMedidos = obra.itens.length > 0 ? (itensMedidos / obra.itens.length) * 100 : 0;
        
        // Resumo de progresso
        doc.setFillColor(230, 230, 230);
        doc.rect(20, yPos - 4, 170, 7, 'F');
        doc.setTextColor(...corPrimaria);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Resumo de Progresso', 22, yPos);
        doc.setFont('helvetica', 'normal');
        yPos += 8;
        
        // Dados de progresso
        doc.setTextColor(...corSecundaria);
        doc.setFontSize(8);
        
        doc.text(`Valor Medido: ${formatarMoeda(valorMedido)} (${percentualConcluido.toFixed(1)}%)`, 22, yPos);
        doc.text(`Itens Medidos: ${itensMedidos} de ${obra.itens.length} (${percentualItensMedidos.toFixed(1)}%)`, 110, yPos);
        yPos += 10;
        
        // Cabeçalho da lista de itens
        doc.setFillColor(230, 230, 230);
        doc.rect(20, yPos - 4, 170, 7, 'F');
        doc.setTextColor(...corPrimaria);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Lista de Itens', 22, yPos);
        doc.setFont('helvetica', 'normal');
        yPos += 10;
        
        // Listar itens
        obra.itens.forEach((item, idx) => {
          // Verificar se precisa adicionar nova página
          if (yPos > 240) {
            doc.addPage();
            yPos = 20;
          }
          
          const progresso = ((item.quantidadeMedida || 0) / item.quantidade * 100).toFixed(1);
          
          doc.setFontSize(8);
          doc.setTextColor(...corPrimaria);
          doc.setFont('helvetica', 'bold');
          doc.text(`Item ${idx + 1}: ${item.item}`, 22, yPos);
          doc.setFont('helvetica', 'normal');
          yPos += 5;
          
          doc.setFontSize(7);
          doc.setTextColor(...corSecundaria);
          doc.text(`Descrição: ${item.descricao}`, 25, yPos);
          yPos += 4;
          
          doc.text(`Unidade: ${item.unidade}`, 25, yPos);
          doc.text(`Quantidade: ${formatarNumero(item.quantidade)}`, 70, yPos);
          doc.text(`Quantidade Medida: ${formatarNumero(item.quantidadeMedida || 0)}`, 120, yPos);
          yPos += 4;
          
          doc.text(`Preço: ${formatarMoeda(item.preco)}`, 25, yPos);
          doc.text(`Total: ${formatarMoeda(item.total)}`, 70, yPos);
          doc.text(`Total Medido: ${formatarMoeda(item.totalMedido || 0)}`, 120, yPos);
          yPos += 4;
          
          doc.text(`Progresso: ${progresso}%`, 25, yPos);
          yPos += 6;
          
          // Barra de progresso
          doc.setDrawColor(...corSecundaria);
          doc.setFillColor(...corDestaque);
          doc.rect(25, yPos - 3, 100, 3, 'S');
          doc.rect(25, yPos - 3, 100 * (progresso / 100), 3, 'F');
          
          yPos += 8;
        });
        
        yPos += 5;
      } else {
        doc.setFontSize(8);
        doc.setTextColor(...corSecundaria);
        doc.text('Sem itens cadastrados', 25, yPos);
        yPos += 5;
      }
      
      // Linha separadora entre obras
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.2);
      doc.line(20, yPos, 190, yPos);
      yPos += 10;
      
      // Verificar se precisa adicionar nova página
      if (yPos > 260) {
        doc.addPage();
        yPos = 20;
      }
    });
    
    yPos += 5;
  });
  
  // Adicionar página para totalizadores
  doc.addPage();
  
  // Cabeçalho da página de totalizadores
  doc.setFillColor(...corDestaque);
  doc.rect(0, 0, 210, 25, 'F');
  
  doc.setFontSize(18);
  doc.setTextColor(255);
  doc.text('Resumo Geral', 105, 15, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setTextColor(230);
  doc.text(`Prefeitura Teste`, 105, 22, { align: 'center' });
  
  // Totalizadores
  yPos = 40;
  
  // Tabela de totalizadores
  doc.setFillColor(245, 245, 245);
  doc.rect(40, yPos - 5, 120, 10, 'F');
  doc.setFontSize(10);
  doc.setTextColor(...corPrimaria);
  doc.setFont('helvetica', 'bold');
  doc.text('Indicador', 45, yPos);
  doc.text('Valor', 145, yPos, { align: 'center' });
  yPos += 10;
  
  // Calcular percentuais
  const percentualValorMedido = valorTotalObras > 0 ? (valorTotalMedido / valorTotalObras) * 100 : 0;
  const percentualItensMedidos = totalItens > 0 ? (totalItensMedidos / totalItens) * 100 : 0;
  
  // Dados dos totalizadores
  const totalizadores = [
    ['Total de Obras', obras.length.toString()],
    ['Valor Total das Obras', formatarMoeda(valorTotalObras)],
    ['Valor Total Medido', formatarMoeda(valorTotalMedido)],
    ['Percentual Medido', `${percentualValorMedido.toFixed(1)}%`],
    ['Total de Itens', totalItens.toString()],
    ['Itens com Medição', totalItensMedidos.toString()],
    ['Percentual de Itens Medidos', `${percentualItensMedidos.toFixed(1)}%`],
    ['Total de Medições Realizadas', totalMedicoes.toString()],
    ['Média de Medições por Obra', obras.length > 0 ? (totalMedicoes / obras.length).toFixed(1) : '0']
  ];
  
  // Agrupar por status
  const contagemPorStatus = {};
  obras.forEach(obra => {
    const status = obra.status || 'Sem Status';
    contagemPorStatus[status] = (contagemPorStatus[status] || 0) + 1;
  });
  
  Object.entries(contagemPorStatus).forEach(([status, quantidade]) => {
    totalizadores.push([`Obras com Status "${status}"`, quantidade.toString()]);
  });
  
  // Desenhar tabela de totalizadores
  doc.setFontSize(9);
  totalizadores.forEach((row, index) => {
    // Alternar cor de fundo
    if (index % 2 === 0) {
      doc.setFillColor(245, 245, 245);
      doc.rect(40, yPos - 5, 120, 8, 'F');
    }
    
    // Título em negrito
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...corPrimaria);
    doc.text(row[0], 45, yPos);
    
    // Valor
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...corSecundaria);
    doc.text(row[1], 145, yPos, { align: 'center' });
    
    yPos += 8;
  });
  
  // Rodapé
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    
    // Linha do rodapé
    doc.setDrawColor(...corDestaque);
    doc.setLineWidth(0.5);
    doc.line(15, 280, 195, 280);
    
    // Texto do rodapé
    doc.setFontSize(8);
    doc.setTextColor(...corSecundaria);
    doc.text(`Página ${i} de ${pageCount}`, 105, 287, { align: 'center' });
    doc.text('Sistema de Gestão de Obras Fixas', 105, 292, { align: 'center' });
  }
  
  // Salvar o PDF
  doc.save('relatorio_obras_fixas.pdf');
};

// Funções auxiliares
const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor || 0);
};

const formatarNumero = (numero) => {
  return new Intl.NumberFormat('pt-BR').format(numero || 0);
};

const formatarData = (data) => {
  if (!data) return 'Não informada';
  
  try {
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR');
  } catch (error) {
    return 'Data inválida';
  }
};

export default {
  gerarRelatorioObrasFixas
};